import React from 'react';

import { SecondaryButton } from '@components/Button/variants';
import VerticalAdvertisement from '@components/FeaturedPartnerAd/Vertical';
import UnitHeader from '@components/FeedItems/UnitHeader';
import useEventTracking from '@hooks/useEventTracking';
import { FeedUnit } from '@interfaces/homepage';
import { ClickTarget, click, transformUnitNameToLocation } from '@tracking';
import { FeedContentType } from '@utils/enums';

import NewsletterCard from './NewsletterCard';

interface FeaturedNewslettersUnitProps {
  feedUnit: FeedUnit;
}

const FeaturedNewslettersUnit = ({
  feedUnit: { unitName, unitDescription, viewAllUrl, content },
}: FeaturedNewslettersUnitProps) => {
  const trackingLocation = transformUnitNameToLocation(unitName);
  const { Track, trackEvent } = useEventTracking({
    location: trackingLocation,
  });

  return (
    <Track>
      <div
        className="border-0 border-b border-solid border-grayscale-gray px-16 py-32 sm:px-0 sm:py-48"
        data-testid="featured-newsletters-unit"
      >
        <UnitHeader
          isTheWeekend={false}
          unitName={unitName}
          unitDescription={unitDescription}
          viewAllUrl={viewAllUrl}
        />
        <div className="flex flex-col justify-between sm:flex-row">
          {content.map((contentItem, index: number) =>
            contentItem.contentType === FeedContentType.Advertisement ? (
              <VerticalAdvertisement
                key={`${unitName}-${index}`}
                advertisement={contentItem}
                className="sm:max-w-[258px]"
                trackingLocation={trackingLocation}
              />
            ) : (
              <NewsletterCard
                key={`${unitName}-${index}`}
                newsletter={contentItem}
                contentIndex={index}
              />
            )
          )}
        </div>
        <SecondaryButton
          onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.ViewAllNewsletters }))}
          as="link"
          href={viewAllUrl}
          className="inline-block sm:hidden"
        >
          View all
        </SecondaryButton>
      </div>
    </Track>
  );
};

export default FeaturedNewslettersUnit;
